<template>
  <Modal @close="$emit('close')">
    <template v-slot:body>
      <div class="text-center">
        <Icon :type="type" />

        <div class="ds-text-xl font-bold text-gray-1000 mt-4">
          <slot name="heading" />
        </div>

        <div class="ds-text-base font-regular text-gray-900 my-4">
          <slot name="body" />
        </div>
      </div>
    </template>

    <template v-slot:actions>
      <div class="flex justify-center">
        <div class="grid gap-2 flex-1 md:flex-none" style="grid-auto-flow: column">
          <slot name="cancel">
            <Button color="red" emphasis="low" text="Cancel" @click="$emit('close')" />
          </slot>

          <slot name="confirm">
            <Button color="blue" emphasis="high" text="Confirm" />
          </slot>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import { Modal } from '@sportsrecruits/playbook';
import Icon from "./Icon";
import { Button } from '@sportsrecruits/playbook';

export default {
  components: {
    Button,
    Icon,
    Modal
  },

  props: {
    type: { type: String, required: true }
  },

  computed: {
    icon() {
      return {
        warning: "sr-2 sr-v2-exclamation-circle text-orange-300"
      }[this.type];
    }
  }
};
</script>